import React, { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { CarouselPaymentPlace, Offer, PaymentPlace } from '@funtech-int/yango-shared';

import { getEmptyOffer } from '../lib/offers';

interface PaywallContextValue {
    offer: Offer;
    paymentPlace?: PaymentPlace;
}

const PaywallContext = createContext<PaywallContextValue | null>(null);

export const usePaywallContext = (): PaywallContextValue => {
    const context = useContext(PaywallContext);

    if (!context) {
        throw new Error('usePaywallContext must be used within PaywallProvider');
    }

    return context;
};

interface PaywallProviderProps {
    offer?: Offer | undefined | null;
    paymentPlace?: CarouselPaymentPlace | PaymentPlace;
    children: ReactNode;
}

export const PaywallProvider = ({ offer, paymentPlace, children }: PaywallProviderProps) => {
    const value = useMemo(
        () => ({
            offer: offer ?? getEmptyOffer(),
            paymentPlace: paymentPlace as PaymentPlace,
        }),
        [offer, paymentPlace]
    );

    return React.createElement(PaywallContext.Provider, { value }, children);
};
